import type { HelpFile } from '../../types/help'
import { SapHcmInboundConfigEditDialogTestIds } from '../../../testids/SapHcmInboundConfigEditDialogTestIds'

export const sapHcmInboundConfigEditDialogHelp: HelpFile = {
  docPage: '/docs/connectors/sap-hcm-connector',
  texts: {
    [SapHcmInboundConfigEditDialogTestIds.btnCancelSapHcmConfig]: null,
    [SapHcmInboundConfigEditDialogTestIds.btnSaveSapHcmConfig]: null,
    [SapHcmInboundConfigEditDialogTestIds.selectSapHcmAuthType]:
      'Authentifizierungsverfahren für den SAP-HCM-OData-V2-Endpunkt. Standard ist BASIC für SAP-interne Benutzer; OAUTH2_CLIENT, wenn das Gateway einen Token-Endpunkt anbietet.',
    [SapHcmInboundConfigEditDialogTestIds.inputSapHcmEmployeeKeyField]:
      'Wire-Feld mit dem Mitarbeiter-Schlüssel. Kanonisch in SAP HCM: PERNR; übersteuern (z. B. auf mitarbeiterNummer), wenn eine deutsche PDQ-Hülle oder ein anderes Wire-Format den Mitarbeiter-Identifier umbenennt.',
    [SapHcmInboundConfigEditDialogTestIds.inputSapHcmValidityStartField]:
      'Wire-Feldname für das Startdatum des Gültigkeitsbands (kanonisch in SAP HCM: BEGDA).',
    [SapHcmInboundConfigEditDialogTestIds.inputSapHcmValidityEndField]:
      'Wire-Feldname für das Enddatum des Gültigkeitsbands (kanonisch in SAP HCM: ENDDA).',
    [SapHcmInboundConfigEditDialogTestIds.sapHcmValiditySelect]:
      'Auflösungsmodus für Gültigkeitsbänder: AS_OF_TODAY wählt das aktuell gültige Band; LATEST das zuletzt gültige; ALL liefert je Band einen Datensatz.',
  },
}
